module.exports = __webpack_public_path__ + "static/media/bohaterowie_powtorkomat.4d7ff0f9.svg";